import axios from "axios";
import { IBooking, IBookingPermission } from "../../types";
import { IBookingsApiFilter, ISortBy } from "../types";

export interface IGetPendingListParams {
    filters: IBookingsApiFilter,
    sortBy?: ISortBy,
    start?: number,
    limit?: number
}

export interface IPendingListRow {
    booking: IBooking,
    permissions: IBookingPermission,
}

export interface IGetPendingListReturn {
    rows: IPendingListRow[]
}

export const getPendingList = async (params: IGetPendingListParams): Promise<IGetPendingListReturn> => {
    const response = await axios.post('/booking/search/pending-list', params);
    return response.data;
};